import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Crosshair } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-50 bg-white border-b-2 border-strong">
      <div className="max-w-[1400px] mx-auto px-6 h-16 flex items-center justify-between">
        <Link to={user ? "/app" : "/"} className="flex items-center gap-2" data-testid="navbar-logo">
          <Crosshair className="w-5 h-5" strokeWidth={2} />
          <span className="font-display font-black text-xl tracking-tighter">FINLENS</span>
          <span className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 ml-1 hidden sm:inline">forensic</span>
        </Link>
        <nav className="flex items-center gap-3 text-xs uppercase tracking-[0.15em]">
          {user ? (
            <>
              <Link to="/app" className="hidden sm:inline hover:underline" data-testid="navbar-dashboard">Dashboard</Link>
              <Link to="/app/analyze" className="hidden sm:inline hover:underline" data-testid="navbar-analyze">Analyze</Link>
              <span className="hidden sm:inline text-zinc-500" data-testid="navbar-usage">
                {user.plan === "owner" ? "Owner" : `${user.usage_this_month}/${user.limit ?? "—"} this month`}
              </span>
              <span className="text-zinc-500 hidden md:inline">{user.email}</span>
              <button
                onClick={async () => { await logout(); nav("/"); }}
                className="border border-strong px-3 py-1.5 hover:bg-black hover:text-white transition-colors"
                data-testid="navbar-logout"
              >Logout</button>
            </>
          ) : (
            <>
              <Link to="/auth" className="hover:underline" data-testid="navbar-login">Login</Link>
              <Link to="/auth?mode=signup" className="bg-black text-white px-4 py-1.5 hover:bg-[#002FA7] transition-colors" data-testid="navbar-signup">
                Get Started
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
